import React, { Component } from 'react';
import { awards } from '../data/awards';

class AwardsDetails extends Component {
    render() {
        const rows = awards.map((award, i) => (
            <tr key={i}>
                <td>{award.name}</td>
                <td>{award.winner}</td>
            </tr>
        ));

        return (
            <div>
                <table className="table">
                    {rows}
                </table>
            </div>
        );
    }
}

export default AwardsDetails;


// WEBPACK FOOTER //
// ./src/components/awardsDetails.jsx